import React from 'react';

import axios from 'axios'
import { Table, Input,Dropdown,Menu,Button,Collapse,Popover,Popconfirm,message,Descriptions,Modal,Spin } from 'antd';
import Highlighter from 'react-highlight-words';
import Icon from '@ant-design/icons';
import { SearchOutlined,DeleteOutlined,FundViewOutlined,WalletFilled,LoadingOutlined,PlusCircleFilled } from '@ant-design/icons';
import { Link, NavLink } from 'react-router-dom';
import CurrencyFormat from 'react-currency-format';
import * as serverconfig from '../serverconn'
var CryptoJS = require("crypto-js");

const { Panel } = Collapse;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

function callback(key) {
  console.log(key);
}


var sacco= ''
var bizuserid= ''
var token= ''

class LoanGuarantorsList extends React.Component {
  state = {
    searchText: '',
    searchedColumn: '',
    loanguarantors: [],
    datarequested:true,
    mdiguarantors: [],

  };

  componentDidMount(){

    if(localStorage.getItem("sacco")){
       sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
       bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
    
    }else{
       sacco= ''
       bizuserid= ''
    
    }
    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }

    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    const applicationID=this.props.match.params.applicationID;

    axios.get(serverconfig.backendserverurl+`/api/loanguarantors/?sacco=${sacco}&loan_attached_to=${applicationID}`)
    .then(res => {
        this.setState({
          loanguarantors:res.data
        })

    })

    axios.get(serverconfig.backendserverurl+`/api/mdiguarantors/?sacco=${sacco}&loanapplication=${applicationID}`)
    .then(res => {
        this.setState({
          mdiguarantors:res.data
        })

        this.setState({datarequested:false})
    })
}



    //////////////////////////////////////////////////
  //handle delete here
  handleDelete = id => {
    axios.delete(`${serverconfig.backendserverurl}/api/loanguarantors/${id}`).then(res =>{
      window.location.reload(false)
      message.info("successfully deleted") 
     }
     );
   
  };

getColumnSearchProps = dataIndex => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8 }}>
      <Input
        ref={node => {
          this.searchInput = node;
        }}
        placeholder={`Search ${dataIndex}`}
        value={selectedKeys[0]}
        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
        onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        style={{ width: 188, marginBottom: 8, display: 'block' }}
      />
      <Button
        type="primary"
        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        icon={<SearchOutlined />}
        size="small"
        style={{ width: 90, marginRight: 8 }}
      >
        Search
      </Button>
      <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
        Reset
      </Button>
    </div>
  ),
  filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
  onFilter: (value, record) =>
    record[dataIndex]
      .toString()
      .toLowerCase()
      .includes(value.toLowerCase()),
  onFilterDropdownVisibleChange: visible => {
    if (visible) {
      setTimeout(() => this.searchInput.select());
    }
  },
  render: text =>
    this.state.searchedColumn === dataIndex ? (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text.toString()}
      />
    ) : (
      text
    ),
});

handleSearch = (selectedKeys, confirm, dataIndex) => {
  confirm();
  this.setState({
    searchText: selectedKeys[0],
    searchedColumn: dataIndex,
  });
};

handleReset = clearFilters => {
  clearFilters();
  this.setState({ searchText: '' });
};

  render() {

      var columns = [

        {
          title: 'Name',
          dataIndex: 'guarantor_name',
          key: 'id',
        },
        {
          title: 'Contact',
          dataIndex: 'RegisteredPhoneNumber1',
          key: 'id',
        },
        {
          title: 'ID Number',
          dataIndex: 'ID_number',
          key: 'id',
        },
        {
          title: 'Action',
          dataIndex: 'id',
          key: 'id',
          render: text =>
          <p>
          <Popover content={<p>Click here to delete</p>} title="Delete">
          <Popconfirm title="Sure to delete?" onConfirm={() => this.handleDelete(text)}>
            <DeleteOutlined style={{color:'red'}}/>
           </Popconfirm>
          </Popover>
          </p>
          ,
        }
  
      ];
    


      var mdiguarantorcolumns = [

        {
          title: 'Account Number',
          dataIndex: 'accountNumber',
          key: 'id',
        },
        {
          title: 'Account Name',
          dataIndex: 'accountName',
          key: 'id',
        },
        {
          title: 'Attached Asset Type',
          dataIndex: 'attached_asset_type',
          key: 'id',
        },
        {
          title: 'Attached Asset',
          dataIndex: 'attached_asset',
          key: 'id',
        },
        {
          title: 'Asset Value',
          dataIndex: 'attached_asset_value',
          key: 'id',
          render:text=><CurrencyFormat value={text} displayType={'text'} thousandSeparator={true}  />

        },
        {
          title: 'Action',
          dataIndex: 'id',
          key: 'id',
          render: text =>
          <p>
          <Popover content={<p>Click here to delete</p>} title="Delete">
          <Popconfirm title="Sure to delete?" onConfirm={() => this.handleDelete(text)}>
            <DeleteOutlined style={{color:'red'}}/>
           </Popconfirm>
          </Popover>
          </p>
          ,
        }
  
      ];      


    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} />
        </div>
      )

    }else{
      return(
        <div>
            <Collapse defaultActiveKey={['1']} onChange={this.callback}>
            <Panel header={<h4 style={{fontWeight:'bolder'}}>LOAN GUARANTORS</h4>} key="1">
            <h3>External Loan Guarantors</h3>
            <Table   
            columns={columns} 
            scroll={{ x: 1000 }}
            dataSource={this.state.loanguarantors} 
            pagination={{showQuickJumper:true,showSizeChanger:true }}
            bordered/>
            <br />
            <h3>MDI/Sacco Guarantors</h3>
            <Table   
            columns={mdiguarantorcolumns} 
            scroll={{ x: 1000 }}
            dataSource={this.state.mdiguarantors} 
            pagination={{showQuickJumper:true,showSizeChanger:true }}
            bordered/>
            </Panel>
            </Collapse>
        </div>
    )


    }
 
  }
}

export default LoanGuarantorsList; 
